import { Dropdown, Avatar, Menu, Space } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import ShoppingCart from '@/assets/images/header/shopping-cart-blue.react.svg?react';
import BuglyIconSgp from '@/assets/images/public/bugly-sgp.react.svg?react';
import BuglyIconBlue from '@/assets/images/public/TDS-bugly-pre.react.svg?react';
import { userImplement } from '@/config/hooks/user';
import { ENV } from '@/infrastructure/env-config';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { OverseasButton } from '@/presentation/components/overseas-button';
import { useAuthContext } from '@/presentation/hooks';
import { TopMenuButton } from '@/presentation/layouts/header/button';
import { stores } from '@/presentation/store';
import { PropsWithStyles } from '@/proto/common';
import style from './index.module.scss';

export const Header = (props: PropsWithStyles<{}>) => {
  const history = useHistory();
  const { authInfo } = useAuthContext();
  const { isSuperUser } = stores.ProductStore;
  const handleSelect = (key: string) => {
    if (key === 'myAppList') {
      history.push('/workbench/apps');
    }
    if (key === 'profile') {
      history.push('/user/profile');
    }
    if (key === 'coupons') {
      history.push('/user/coupons');
    }
    if (key === 'approval') {
      history.push('/product-approval');
    }
    if (key === 'resourceManage') {
      history.push('/resource-manage');
    }
    if (key === 'expense') {
      history.push('/expense');
    }
    if (key === 'logout') {
      userImplement.logout();
    }
  };

  const renderMenu = () => (
    <Menu onClick={({ key }) => handleSelect(key)}>
      <Menu.Item key="myAppList" className={style.headerMenu}>
        我的产品
      </Menu.Item>
      <Menu.Item key="profile" className={style.headerMenu}>
        个人信息
      </Menu.Item>
      {(!ENV.isGlobal) && <Menu.Item key="expense" className={style.headerMenu}>
        订单管理
      </Menu.Item>}
      {(!ENV.isGlobal) && <Menu.Item key="resourceManage" className={style.headerMenu}>
        资源包
      </Menu.Item>}
      {isSuperUser ? <Menu.Item key="approval"  className={style.headerMenu}>
        产品审批
      </Menu.Item> : null}
      {/* <Menu.Item key="coupons">*/}
      {/*  代金券*/}
      {/* </Menu.Item>*/}
      <Menu.Item key="logout" className={style.headerMenu}>
        退出登录
      </Menu.Item>
    </Menu>
  );

  return (
    <div className={classNames(style.header, props.className)} style={props.style}>
      <Link to={'/index/main'}>
        {ENV.isGlobal ? <BuglyIconSgp /> : <BuglyIconBlue />}
      </Link>
      <div className={style.topMenu}>
        <Space style={{ minWidth: 259, justifyContent: 'flex-end' }}>
          {!ENV.isGlobal && <OverseasButton pageId={PAGE_ID.indexMain}/>}
          {!ENV.isGlobal ? <TopMenuButton onClick={() => {
            history.push('/resource-pack');
            reportClick(PAGE_ID.indexMain, CUSTOM_ACTIONS.commonEnterBuyResourcePackPage, {
              from: PAGE_ID.indexMain,
            });
          }}>
            <ShoppingCart />
            <span style={{ color: '#0A6CFF' }}>购买资源包</span>
          </TopMenuButton> : null}
          {!authInfo?.isLoggedIn
            ? <TopMenuButton  onClick={() => userImplement.logout()}>
              <span style={{ cursor: 'pointer' }}>登录</span>
            </TopMenuButton> : null
          }
          {authInfo?.isLoggedIn && <div>
            <Dropdown overlay={renderMenu} arrow placement={'bottomRight'}>
              <Avatar size={28} src={userImplement.getAvatar()} />
            </Dropdown>
          </div>}
        </Space>
      </div>
    </div>
  );
};
